<template>
  <div>

    <h1 class="text-center">A familía é fundamental na vida de nossos alunos e gostariamos que conhecer um pouco mais sobre vocês.</h1>
    <v-divider class="divider-accent my-4"/>

    <!-- responsible section -->
    <v-card class="mb-4">
      <v-flex pa-4>
        <nested-responsibles />
      </v-flex>
    </v-card>

    <!-- emergency contact section  -->
    <v-card class="mb-4">
      <v-flex pa-4>
        <nested-emergency-contacts />
      </v-flex>
    </v-card>

    <!-- siblings section -->
    <v-card class="mb-4">
      <v-flex pa-4>
        <nested-siblings />
      </v-flex>
    </v-card>

    <load-form-handler
      :promise="getTabPromise"
      v-model="resource"
      placeholder
      @error="handleErrorMessage">

        <v-card class="mb-4">
          <v-flex pa-4>
            <form-responsible-finances ref="form_responsible_finances"/>

            <v-divider class="divider-primary my-4"/>

            <h2>Histórico familiar</h2>
            <h2>Familiar history</h2>
            <form-familiar-history
              @update="sendUpdateRequest"
              ref="form_familiar_history"/>

            <v-layout column>
              <v-btn
                large color="primary"
                @click="updateTab"
                style="margin: 0;">
                Salvar / Save
                  <v-icon right dark>save</v-icon>
              </v-btn>
            </v-layout>

          </v-flex>
        </v-card>
      </load-form-handler>

    <alert-modal
    :visibility="declarationModalVisibility"
    title="Confirmação de dados"
    :message="declarationMessage"
    confirmAction="OK"
    cancelAction="CANCELAR"
    @confirm="onDeclarationModal"
    @cancel="closeDeclarationModal" />

  </div>
</template>

<script>
import FormResponsibleFinances from './FormResponsibleFinances'
import FormFamiliarHistory from './FormFamiliarHistory'
import * as api from '@/api'
import LoadFormHandler from '@/components/LoadFormHandler'
import NestedResponsibles from './NestedResponsibles'
import NestedEmergencyContacts from './NestedEmergencyContacts'
import NestedSiblings from './NestedSiblings'
import { formTabs, message, declaration } from '@/mixins'
import AlertModal from '@/components/AlertModal'

export default {
  name: 'FormFamilyData',

  data: () => ({
    resource: {},
    isFormLoading: true,
    forms_references: [
      'form_responsible_finances',
      'form_familiar_history'
    ]
  }),

  components: {
    FormResponsibleFinances,
    FormFamiliarHistory,
    LoadFormHandler,
    NestedResponsibles,
    NestedEmergencyContacts,
    NestedSiblings,
    AlertModal
  },

  mixins: [formTabs, message, declaration],

  provide () {
    const resource = {}
    Object.defineProperty(resource, 'form', {
      enumerable: true,
      get: () => this.resource
    })
    return { resource }
  },

  methods: {
    getTabPromise () {
      return api.forms.familyData.get(this.currentStudentId)
    },

    // @vuese Método para atualização da aba
    updateTab () {
      if (this.validateAllForms()) {
        this.openDeclarationModal()
      } else {
        this.showMessageByType(this.messageTypes.VALIDATION_ERROR)
      }
    },

    // @vuese Método para validação das abas
    validateAllForms () {
      const validations = []

      this.forms_references.map(formRef => {
        validations.push(this.$refs[formRef].validateForm())
      })

      return validations.filter(value => !value).length === 0
    },

    onDeclarationModal () {
      this.sendUpdateRequest(this.resource)
    },

    // @vuese Método para atualização de dados da form
    sendUpdateRequest (resource) {
      api.forms.familyData
        .update(this.resource.id, resource)
        .then(response => {
          this.resource = response.data
          this.$forceUpdate()
          this.showMessageByType(this.messageTypes.MODIFIED)
        })
        .catch(this.handleErrorMessage)
        .finally(this.closeDeclarationModal)
    }
  }
}
</script>
